module.exports = __webpack_public_path__ + "static/media/Sentient_BossMoves.f3f6cbe2.gif";